import { additionalDataDocumentsForm } from 'apps/Onboarding/views/BlueBook/components/Documents/components/DocumentsForm/interface'
import { ECompanyType } from 'utils/constants'
import {
  hasMaxChars,
  hasMinChars,
  hasOnlyDigits,
  isCleanText,
  isNumber,
  isRequired,
  isValidTaxPayerRegister
} from 'utils/validations'
import { IDocumentExampleFieldName } from './interface'
import { TFunction } from 'i18next'

export const T_ROOT = 'wizard.documents'

export const DOCUMENT_EXAMPLE_FILE_NAMES: IDocumentExampleFieldName = {
  '9d66182d-f748-46eb-b838-0a24c4ab862a': ['acta-constitutiva.jpg'],
  '4127f944-12bc-4535-a84d-63cec1af5c4a': ['cedula-fiscal-frente.jpg'],
  '59562f9f-b4b9-492a-bf13-6547be3b58ee': [
    'comprobante-luz-frente.jpg',
    'comprobante-domicilio-frente.jpg',
    'comprobante-predial-frente.jpg',
    'comprobante-telefono-frente.jpg'
  ],
  '583402ef-93c9-42b9-a3af-7e509b703875': [
    'identificacion-oficial-frente.jpg',
    'pasaporte-frente.jpg',
    'documento-migratorio-frente.jpg',
    'cedula-profesional-frente.jpg'
  ],
  '5d136eea-d3de-4b8a-b085-9a524ee0fbd3': [
    'identificacion-oficial-reverso.jpg',
    'cedula-profesional-reverso.jpg',
    'documento-migratorio-reverso.jpg'
  ],
  'tax-regime': ['tax-regime.png'],
  '85ce326c-cb6c-43ce-8529-20bd416b976c': [
    'bank-cover-example-one.png',
    'bank-cover-example-two.png',
    'bank-cover-example-three.png'
  ]
}

export const NO_REQUIRED_DOCUMENTS_BY_MCC: IDocumentExampleFieldName = {
  '0008': ['ef592c86-99e8-4dc8-8e45-9f1b6a22cbc3'],
  '1520': [
    'bc582283-91cb-4522-b227-5b834b3f2365',
    '2be7c274-3f48-4946-89d4-ba8763e75f95',
    '492edab0-f576-49dc-a175-1e37b6a5d749'
  ],
  '2842': ['3ffd3c16-145a-4c24-9dd9-4b0d01845516'],
  '4511': ['3e595d20-4244-42a7-b814-924be4873a4a'],
  '5047': ['ef592c86-99e8-4dc8-8e45-9f1b6a22cbc3'],
  '5411': ['3ffd3c16-145a-4c24-9dd9-4b0d01845516'],
  '5499': ['3ffd3c16-145a-4c24-9dd9-4b0d01845516'],
  '5813': ['bddf62f8-a816-4db7-92db-22ddfa681436'],
  '5921': ['0fcf0627-b409-405b-917e-f3cd55800355'],
  '5977': ['3ffd3c16-145a-4c24-9dd9-4b0d01845516'],
  '5993': ['92597994-d2df-4db4-8620-25a635009603'],
  '7995': ['492edab0-f576-49dc-a175-1e37b6a5d749', '2be7c274-3f48-4946-89d4-ba8763e75f95'],
  '8099': ['3ffd3c16-145a-4c24-9dd9-4b0d01845516'],
  '8641': ['3dd4a5c0-ca75-440b-8d96-5c7070fc9a9e'],
  '8651': ['413c8d9c-0d0d-4dc3-85f2-a2d6faf2079a'],
  '9399': ['413c8d9c-0d0d-4dc3-85f2-a2d6faf2079a']
}

export const IDENTIFICATION_REVERSE_FILE_ID = '5d136eea-d3de-4b8a-b085-9a524ee0fbd3'

export const MAX_FILE_NAME_CHARS = 100

export const inputsProps = (
  t: TFunction
): {
  manualInfo: {
    name: string
    options?: any[]
    type: string
    validations: any[]
    fieldType?: ECompanyType
  }[]
} => ({
  manualInfo: [
    {
      name: 'legalRepresentativeName',
      type: 'text',
      validations: [isRequired(t), isCleanText(t), hasMaxChars(t, 150)],
      fieldType: ECompanyType.LEGAL
    },
    {
      name: 'legalRepresentativeBirthdate',
      type: 'date',
      validations: [isRequired(t)],
      fieldType: ECompanyType.LEGAL
    },
    {
      name: 'taxPayerRegister',
      type: 'text',
      validations: [isRequired(t), isCleanText(t), hasMinChars(t, 12), hasMaxChars(t, 13), isValidTaxPayerRegister(t)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'taxRegime',
      type: 'select',
      validations: [isRequired(t)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'commercialLegalName',
      type: 'text',
      validations: [isRequired(t)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'street',
      type: 'text',
      validations: [isRequired(t)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'externalNumber',
      type: 'text',
      validations: [isRequired(t), hasMaxChars(t, 50)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'interiorNumber',
      type: 'text',
      validations: [isRequired(t)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'zip',
      type: 'text',
      validations: [isRequired(t), isCleanText(t), hasOnlyDigits(t), isNumber(t), hasMaxChars(t, 6)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'neighborhood',
      type: 'text',
      validations: [isRequired(t), hasMaxChars(t, 100)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'municipality',
      type: 'text',
      validations: [isRequired(t), isCleanText(t), hasMaxChars(t, 250)],
      fieldType: ECompanyType.FISCAL
    },
    {
      name: 'state',
      type: 'text',
      validations: [isRequired(t), isCleanText(t), hasMaxChars(t, 100)],
      fieldType: ECompanyType.FISCAL
    }
  ]
})

export const bankCoverFileId = '85ce326c-cb6c-43ce-8529-20bd416b976c'

export const manualInfoValidations: string[] = [
  'legalRepresentativeName',
  'legalRepresentativeBirthdate',
  'taxPayerRegister',
  'taxRegime',
  'commercialLegalName',
  'street',
  'externalNumber',
  'interiorNumber',
  'zip',
  'neighborhood',
  'municipality',
  'state'
]

export const LEGAL_FIELDS = ['legalRepresentativeName', 'legalRepresentativeBirthdate']

export const FISCAL_FIELDS = [
  'commercialLegalName',
  'street',
  'externalNumber',
  'interiorNumber',
  'zip',
  'neighborhood',
  'municipality',
  'state',
  'taxPayerRegister',
  'taxRegime'
]

export const parameterMap: {
  [key: string]: keyof additionalDataDocumentsForm
} = { fiscal: 'fiscal', legal: 'legal' }
